<template>
  <v-carousel
    v-if="products && products.products && settings.layout === 'vertical' && $vuetify.breakpoint.mdAndUp"
    hide-delimiters
    :show-arrows="
      $vuetify.breakpoint.mdAndUp &&
        splitArray &&
        splitArray.length &&
        splitArray.length > 1
    "
    :cycle="!$vuetify.breakpoint.mdAndUp"
  >
    <v-carousel-item v-for="(carousel, index) in splitArray" :key="index">
      <v-container style="overflow: auto" fill-height>
        <v-row no-gutters justify="center" align="center">
          <v-col
            v-for="(item, i) in splitArray[index]"
            :key="i"
            :cols="12 / settings['max-columns']"
            align="center"
          >
            <v-card
              elevation="0"
              max-width="255"
              height="100%"
              max-height="100%"
              class="mt-3 mx-2"
              :color="settings['item-background-color']"
            >
              <v-row no-gutters justify="start" align="start">
                <v-col align="center">
                  <v-row
                    style="height: 100%; min-height: 100px; display: flex; justify-content: center; align-items: center"
                    justify="center"
                    class="pt-2 px-8 "
                    no-gutters
                  >
                    <b class="ticketName black--text">
                      {{ item.nome }} - {{ item.nome_tipo }}
                    </b>
                  </v-row>

                  <v-card
                    class="mx-9 mb-5 mt-5"
                    elevation="0"
                    color="transparent"
                    height="200px"
                  >
                    <v-row no-gutters justify="center">
                      <v-col align="start">
                        <span
                          style="white-space: pre-line; text-align: left !important"
                          class="description black--text"
                        >
                          {{ descriptionVertical(item) }}
                        </span>
                        <dialog-ticket
                          class="mr-3 py-2"
                          v-if="item.observacoes && item.observacoes.length >= 150"
                          :item="item"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                  <!-- </v-list-item> -->
                </v-col>
              </v-row>
              <v-card-actions>
                <v-row
                  justify="center"
                  class="py-5"
                  no-gutters
                  align="center"
                >
                  <v-col>
                    <v-row class="mb-1" justify="center">
                      <b v-show="!item.encerrado" class="black--text">
                        {{
                          item.valor + item.valor_conveniencia
                            ? `R$ ${(item.valor + item.valor_conveniencia)
                                .toFixed(2)
                                .replace(".", ",")}`
                            : "Grátis"
                        }}
                      </b>
                    </v-row>
                    <v-btn
                      dark
                      elevation="0"
                      @click="openCheckout(item)"
                      :style="
                        `
                        background-color: ${MIXIN_getStyle(settings, 'button', 'background-color')} !important;
                        border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius')} !important
                        `
                      "
                      :readonly="!!item.encerrado"
                      >
                      <b
                        :style="
                          `
                            color: ${MIXIN_getStyle(settings, 'button', 'color')} !important;
                          `
                        "
                        >
                        {{item.encerrado ? "Encerrado" : item.valor + item.valor_conveniencia ? "Comprar" : "Fazer Inscrição"}}
                        </b>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from '../../../mixins/GetLayoutSection'
import DialogTicket from '../DialogTicket.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  components: { DialogTicket },
  props: {
    settings: {type: Object},
    splitArray: {type: Array},
    openCheckout: {type: Function}
  },

  computed: {
    ...mapGetters(["products", "oneCheckoutOpen", "infos", "tickets", "productErrorMessage"]),
  },

  methods: {
    descriptionVertical(item) {
      if (item.observacoes) {
        if (item.observacoes.length >= 80 && item.observacoes.includes("\n")) {
          return `${item.observacoes.slice(0, 80)}...`;
        } else if (
          item.observacoes.length >= 135 &&
          !item.observacoes.includes("\n")
        ) {
          return `${item.observacoes.slice(0, 135)}...`;
        } else return item.observacoes;
      } else return "";
    }    
  }
}
</script>

<style scoped>
  .ticketName {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.25px;
  }

  .description {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    /* text-align: left; */
  }
</style>